/* Dark Forest B2B — conversion-path fixes for the quote journey.
   Mission b2b-quote-path-2026-09-21, dark-conversion. Lock: cro-b2b-components.

   Loaded in layout/b2b-r8-20260905.liquid immediately BEFORE b2b-r8-20260905-app.js
   (same <head>, both `defer`, so document order guarantees this runs first — the same
   mechanism b2b-analytics.js already relies on, kb/b2b-configurator.md).

   Nothing here edits the compiled bundle. Everything is additive and removable by
   deleting this file's <script> tag. Four fixes, each proven against the RENDERED DOM
   on 2026-09-21:

   1. EMPTY ROUTE DRAFTS.  The app writes an empty destination/shipping draft for the
      route the buyer is NOT using ({"country":"","otherCountry":""} and
      {"address":{"country":""},"methodId":""}), then on the next visit judges it
      "invalid or incomplete" and prints a data-loss warning at the top of the page —
      while the buyer's own selection is restored intact on screen. Proven twice:
      quantity 48 + country US came back correctly and the warning still fired.
      This removes ONLY drafts in which every leaf value is empty, so by construction
      nothing a buyer chose can be lost.

   2. SAME-PAGE ANCHORS THAT RELOAD THE PAGE.  On /pages/partners the four in-page jump
      links carry absolute hrefs (https://darkforesttarotcards.com/pages/partners#...).
      From any URL with a query string — every UTM-tagged ad arrival — clicking one
      loads a new document (3.9 MB, 216 requests) and drops the query string with it.
      This scrolls instead, and keeps the query string in the address bar.

   3. OFF-SITE FILES OPENING IN THE BUYER'S OWN TAB.  The 43.2 MB template ZIP and the
      24 MB print guide on /pages/tarot-deck-printing-specification carry `download`
      (ignored cross-origin) and no target, so they navigate the tab off the store and
      take the configurator draft and the enquiry form with them. Same class as the
      standing sitewide defect N-1.

   4. AN ENQUIRY THAT SILENTLY FAILS.  POST /contact is refused server-side without an
      hCaptcha token (verified: HTTP 400 "Missing CAPTCHA token"). When hCaptcha
      escalates to an image challenge its own full-viewport scrim intercepts the click
      on "Send question", and if the buyer closes it the page shows no error at all —
      the form keeps its values and looks idle. This gives the button a sending state
      and, if nothing has happened after 6 s, one line telling the buyer what to do.
*/
(function () {
  'use strict';
  if (window.__dfB2BCroInit) return;
  window.__dfB2BCroInit = true;

  /* ---------- 1. drop drafts that hold nothing, before the app validates them ---------- */
  function isEmptyDeep(v) {
    if (v === null || v === undefined || v === '') return true;
    if (typeof v === 'number' || typeof v === 'boolean') return false;
    if (typeof v === 'string') return v.trim() === '';
    if (Array.isArray(v)) return v.every(isEmptyDeep);
    if (typeof v === 'object') {
      var ks = Object.keys(v);
      if (!ks.length) return true;
      return ks.every(function (k) { return isEmptyDeep(v[k]); });
    }
    return false;
  }
  try {
    var keys = [];
    for (var i = 0; i < localStorage.length; i++) {
      var k = localStorage.key(i);
      if (k && /^df-local-/.test(k)) keys.push(k);
    }
    keys.forEach(function (key) {
      var raw = localStorage.getItem(key);
      if (raw == null) return;
      var parsed;
      try { parsed = JSON.parse(raw); } catch (e) { return; }
      if (isEmptyDeep(parsed)) localStorage.removeItem(key);
    });
  } catch (e) {}

  /* ---------- 2. same-document anchors scroll instead of reloading ---------- */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href.indexOf('#') === -1) return;
    if (a.getAttribute('target')) return;
    /* opt-out for links that MUST reload the document, e.g. "Ask another question",
       which reloads the page without ?contact_posted=true to bring the form back */
    if (a.hasAttribute('data-df-full-load')) return;
    var u;
    try { u = new URL(a.href, location.href); } catch (err) { return; }
    if (u.origin !== location.origin) return;
    if (u.pathname !== location.pathname) return;
    if (u.search !== '' && u.search !== location.search) return;
    if (!u.hash || u.hash === '#') return;
    var target;
    try { target = document.getElementById(decodeURIComponent(u.hash.slice(1))); } catch (err) { target = null; }
    if (!target) return;
    e.preventDefault();
    try { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    catch (err) { target.scrollIntoView(); }
    try { history.pushState(null, '', location.pathname + location.search + u.hash); } catch (err) {}
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    try { target.focus({ preventScroll: true }); } catch (err) {}
  }, false);

  /* ---------- 3. off-site links leave the store in a new tab ---------- */
  function hardenExternalLinks(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var list;
    try { list = scope.querySelectorAll('a[href^="http"]'); } catch (e) { return; }
    for (var i = 0; i < list.length; i++) {
      var a = list[i];
      if (a.getAttribute('target')) continue;
      var u;
      try { u = new URL(a.href); } catch (err) { continue; }
      if (u.origin === location.origin) continue;
      a.setAttribute('target', '_blank');
      var rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
      if (rel.indexOf('noopener') === -1) rel.push('noopener');
      a.setAttribute('rel', rel.join(' '));
    }
  }

  /* ---------- 4. the enquiry form says what it is doing ---------- */
  var LC = (function () { var h = location.pathname.split("/").filter(Boolean)[0] || ""; return ({ "de-de": "de", "de-at": "de", "fr-fr": "fr", "es-es": "es", "es-latam": "es", "it-it": "it", "ja-jp": "ja" })[h] || "en"; })();
  var LS = {"en": {"s": "Sending…", "h": null}, "de": {"s": "Wird gesendet…", "h": "Nichts passiert? Möglicherweise hat sich eine Sicherheitsprüfung vor der Seite geöffnet – schließen Sie sie ab und senden Sie erneut. Falls es nicht klappt, schreiben Sie an support@darkforesttarotcards.com, wir antworten von dort."}, "fr": {"s": "Envoi…", "h": "Rien ne s'est passé ? Une vérification de sécurité s'est peut-être ouverte devant la page – terminez-la et renvoyez. Si cela ne passe pas, écrivez à support@darkforesttarotcards.com et nous répondrons de là."}, "es": {"s": "Enviando…", "h": "¿No ha pasado nada? Puede que se haya abierto una comprobación de seguridad delante de la página: complétela y vuelva a enviar. Si no funciona, escriba a support@darkforesttarotcards.com y le responderemos desde allí."}, "it": {"s": "Invio…", "h": "Non è successo nulla? Potrebbe essersi aperto un controllo di sicurezza davanti alla pagina: lo completi e invii di nuovo. Se non funziona, scriva a support@darkforesttarotcards.com e risponderemo da lì."}, "ja": {"s": "送信中…", "h": "反応がありませんか？ページの手前にセキュリティ確認が開いている場合があります。完了してからもう一度送信してください。うまくいかない場合は support@darkforesttarotcards.com までご連絡ください。"}};
  var SEND_HINT = 'Nothing happened? A security check may have opened in front of the page — finish it and press Send question again. If it will not go through, write to support@darkforesttarotcards.com and we will answer from there.';
  function wireQuestionForm() {
    var f = document.getElementById('B2BContactForm');
    if (!f || f.getAttribute('data-df-cro-wired')) return;
    var btn = f.querySelector('button[type="submit"]');
    if (!btn) return;
    f.setAttribute('data-df-cro-wired', '1');

    var hint = document.createElement('p');
    hint.className = 'small df-send-hint';
    hint.id = 'df-send-hint';
    hint.setAttribute('role', 'status');
    hint.hidden = true;
    hint.innerHTML = (LS[LC].h || SEND_HINT).replace(
      'support@darkforesttarotcards.com',
      '<a href="mailto:support@darkforesttarotcards.com?subject=Wholesale%20enquiry">support@darkforesttarotcards.com</a>'
    );
    if (btn.parentNode) btn.parentNode.insertBefore(hint, btn.nextSibling);

    f.addEventListener('submit', function () {
      /* Hand the merchant what the buyer already configured, without asking for it.
         Three fields stay three fields; the hidden Selection line carries route,
         quantity, destination, buyer type and the estimate the app is showing. */
      try {
        var sel = document.getElementById('b2b-question-selection');
        if (sel) {
          var parts = [];
          var route = null;
          try { route = new URLSearchParams(location.search).get('route'); } catch (err) {}
          if (!route && document.body && document.body.dataset) route = document.body.dataset.page || null;
          if (route) parts.push('route=' + route);
          var q = document.querySelector('#quantity');
          if (q && q.value) parts.push('quantity=' + q.value);
          var c = document.querySelector('#country, #review-country');
          if (c && c.value) parts.push('country=' + c.value);
          var bt = document.querySelector('#buyer_type');
          if (bt && bt.value) parts.push('buyer=' + bt.value);
          var tot = document.querySelector('#estimate .total .money, #b2b-quote-review .total .money');
          if (tot && tot.textContent.trim()) parts.push('estimate=' + tot.textContent.trim());
          sel.value = parts.join(' | ');
        }
      } catch (err) {}

      var original = btn.textContent;
      btn.setAttribute('aria-busy', 'true');
      btn.setAttribute('data-df-sending', '1');
      btn.textContent = LS[LC].s;
      window.setTimeout(function () {
        if (!document.body.contains(btn)) return;
        btn.removeAttribute('aria-busy');
        btn.removeAttribute('data-df-sending');
        btn.textContent = original;
        hint.hidden = false;
      }, 6000);
    });
  }

  /* ---------- run, and re-run for anything the app draws later ---------- */
  function pass() {
    hardenExternalLinks(document);
    wireQuestionForm();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pass);
  } else {
    pass();
  }
  window.addEventListener('load', pass);

  var scheduled = null;
  function schedule() {
    if (scheduled) return;
    scheduled = window.setTimeout(function () { scheduled = null; pass(); }, 250);
  }
  try {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
